(() => {
 'use strict';
 const mobile = matchMedia('(max-width:767.98px)');
 const filterCompact = matchMedia('(max-width:767.98px), (min-width:768px) and (max-width:1199.98px) and (orientation:portrait)');
 const filterWrappers = new Set();
 const nativeFilters = new Map();
 const wrappers = new Set();
 const gaps = new Set();
 const spaces = new Set();
 const nativeSelector = 'details.enigma-catalog__filter-panel,details.enigma-search__filters,details.mtg-catalog__filter-shell';
 const gapSelector = '.eh-main,.eh-banners,.eh-home,.eh-preorders,.mtg-singles-gateway,.mtg-commerce-preorder-grid,.tcg-commerce-preorder-grid';
 function filters() {
  document.querySelectorAll(nativeSelector).forEach(panel => {
   const summary=panel.querySelector('summary');
   if(filterCompact.matches&&summary&&!summary.querySelector('svg,.enigma-mobile-filter-icon')){
    summary.insertAdjacentHTML('afterbegin','<svg class="enigma-mobile-filter-icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M3 5h18M6 12h12M9 19h6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>');
   }
   if (nativeFilters.has(panel)) return;
   nativeFilters.set(panel,panel.open);
   if (filterCompact.matches) panel.open=false;
  });
  if (!filterCompact.matches) return;
  document.querySelectorAll('.enigma-special-filters,.enigma-sealed-controls').forEach(form => {
   if (form.closest('details')) return;
   const panel=document.createElement('details');
   panel.className='enigma-mobile-filter-disclosure';
   const summary=document.createElement('summary');
   summary.innerHTML='<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M3 5h18M6 12h12M9 19h6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
   summary.append(document.documentElement.lang.startsWith('it')?'Filtri e ordinamento':'Filters and sorting');
   form.before(panel); panel.append(summary,form); filterWrappers.add(panel);
  });
 }
 function spacing() {
  if (!mobile.matches) return;
  const gapWrites=[];
  document.querySelectorAll(gapSelector).forEach(el => {
   if (gaps.has(el)) return;
   const gap=parseFloat(getComputedStyle(el).rowGap);
   if (!(gap>0)) return;
   gapWrites.push(()=>{
    el.style.setProperty('--enigma-mobile-doubled-gap',`${gap*2}px`);
    el.setAttribute('data-enigma-mobile-gap','');gaps.add(el);
   });
  });
  gapWrites.forEach(write=>write());
  // Section distances use the doubled gaps, then all distances are captured
  // before margin writes. Moving a preceding section preserves sibling gaps.
  const spaceWrites=[];
  const groups=['#MainContent','.enigma-mtg-hub-commerce','.enigma-tcg-hub-commerce','.mh-wrap','.th-wrap'];
  groups.forEach(selector => document.querySelectorAll(selector).forEach(parent => {
   let previous=null;
   const children=Array.from(parent.children).filter(el=>el.matches('.shopify-section,section,.mtg-commerce-rail,.tcg-commerce-rail,.mtg-commerce-preorders,.tcg-commerce-preorders'));
   // The first sibling cannot need spacing; processed successors need no distance decision.
   if(children.slice(1).every(el=>spaces.has(el)))return;
   children.map(el=>({el,rect:el.getBoundingClientRect()})).filter(item=>item.rect.height>0).forEach(({el,rect})=>{
    if(previous&&!spaces.has(el)){
     const distance=Math.max(0,rect.top-previous.bottom);
     const margin=parseFloat(getComputedStyle(el).marginTop)||0;
     if(distance>0)spaceWrites.push(()=>{el.style.setProperty('--enigma-mobile-doubled-space',`${Math.max(margin,distance)+distance}px`);el.setAttribute('data-enigma-mobile-section-space','');spaces.add(el);});
    }
    previous=rect;
   });
  }));
  spaceWrites.forEach(write=>write());
 }
 function banners(){
  if(!mobile.matches)return;
  document.querySelectorAll('.eh-banners > [aria-label="Strumenti per la collezione"],.eh-banners > [aria-label="Collection tools"],.eh-banners > .eh-banner-gift').forEach(section=>{
   if(section.querySelector(':scope > .enigma-mobile-banner-disclosure'))return;
   const panel=document.createElement('details');panel.className='enigma-mobile-banner-disclosure';
   const summary=document.createElement('summary');
   summary.textContent=section.classList.contains('eh-banner-gift')?'Gift card':(document.documentElement.lang.startsWith('it')?'Trova carta':'Find a card');
   const content=document.createElement('div');content.className='enigma-mobile-banner-content';
   while(section.firstChild)content.append(section.firstChild);
   panel.append(summary,content);section.append(panel);wrappers.add(panel);
   panel.addEventListener('toggle',()=>{if(panel.open)window.dispatchEvent(new Event('resize'));});
  });
 }
 function services(){
  if(!mobile.matches)return;
  document.querySelectorAll('.enigma-services-sidebar').forEach(nav=>{
   if(nav.querySelector('.enigma-mobile-services-disclosure'))return;
   const heading=nav.querySelector('h2');
   const links=nav.querySelector('.enigma-services-links');
   if(!heading||!links)return;
   const panel=document.createElement('details');panel.className='enigma-mobile-services-disclosure';
   const summary=document.createElement('summary');
   heading.before(panel);summary.append(heading);panel.append(summary,links);wrappers.add(panel);
  });
 }
 function init(){filters();banners();services();spacing();}
 mobile.addEventListener('change',()=>{
  wrappers.forEach(panel=>{panel.open=!mobile.matches;});
  init();
 });
 filterCompact.addEventListener('change',()=>{
  nativeFilters.forEach((original,panel)=>{panel.open=filterCompact.matches?false:original;});
  filterWrappers.forEach(panel=>{panel.open=!filterCompact.matches;});
  filters();
 });
 let scheduled=false;
 function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 window.addEventListener('load',init,{once:true});
 document.addEventListener('shopify:section:load',init);
 // Product text, quantities and carousel labels do not create enhancements.
 // Still process inserted sections, filter forms and disclosure containers.
 const enhancementSelector=nativeSelector+','+gapSelector+',.enigma-special-filters,.enigma-sealed-controls,.enigma-services-sidebar,.eh-banner-gift,.shopify-section,section,.mtg-commerce-rail,.tcg-commerce-rail,.mtg-commerce-preorders,.tcg-commerce-preorders';
 new MutationObserver(records=>{
  if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches(enhancementSelector)||node.querySelector(enhancementSelector)))))schedule();
 }).observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
})();
